import { render, staticRenderFns } from "./loIndex.vue?vue&type=template&id=70f6e916&scoped=true&"
import script from "./loIndex.vue?vue&type=script&lang=js&"
export * from "./loIndex.vue?vue&type=script&lang=js&"
import style0 from "./loIndex.vue?vue&type=style&index=0&id=70f6e916&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f6e916",
  null
  
)

export default component.exports